import { PromotionListParams } from "@/repositories/promotion";

export const PROMOTION_KEY = "PROMOTION";

export const PROMOTION_CACHE_KEYS = {
  LISTS: [PROMOTION_KEY, "LIST"] as const,
  LIST: (params: PromotionListParams) =>
    [PROMOTION_KEY, "LIST", params] as const,
  DETAIL: (id: string) => [PROMOTION_KEY, "DETAIL", id] as const,
};
